/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonGroup,
    JsonGroupFromJSON,
    JsonGroupFromJSONTyped,
    JsonGroupToJSON,
} from './JsonGroup';

/**
 * 
 * @export
 * @interface ApiResultOfJsonGroup
 */
export interface ApiResultOfJsonGroup {
    /**
     * 
     * @type {JsonGroup}
     * @memberof ApiResultOfJsonGroup
     */
    data?: JsonGroup;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonGroup
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonGroup
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonGroup
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonGroup
     */
    result?: ApiResultOfJsonGroupResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonGroupResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonGroupFromJSON(json: any): ApiResultOfJsonGroup {
    return ApiResultOfJsonGroupFromJSONTyped(json, false);
}

export function ApiResultOfJsonGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonGroupFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonGroupToJSON(value?: ApiResultOfJsonGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonGroupToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

